// extracted by mini-css-extract-plugin
module.exports = {"root":"EditBulletin_root__yxgxu"};